<template>
<div>   
    <section class="mt-5">
        <b-carousel :interval="4000"
                    background="#ababab">
          <b-carousel-slide :img-src="isMobile ? 'cantado/banner_mobil.jpg' : 'cantado/banner.jpg'">
          </b-carousel-slide>
        </b-carousel>
    </section>
    <hr>
    <div class="row justify-content-center" >
        <div class="col-md-5">
            <hr style="border-top: 5px solid #56CB00 !important;  opacity :0.8;">
        </div>
    </div>
    <div style="  margin-top: -12px; box-shadow: 0px 0px 10px 1px #AFAFAF;" id="fondo">
        <form @submit="login">
            <div class="text-center ">
                <br>
                <b-tabs pills align="center">
                    <b-tab title="Ejecutivo / Gerente" active @click="tipo = 1">    
                        <div class="row justify-content-center">
                            <div class="col-md-11 mt-4"> 
                                <p>Ingresa los datos solicitados:</p>
                            </div>
                        
                            <div class="col-md-3 col-11 mt-4">
                                <b-form-input placeholder="Correo"  v-model="email" type="text"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;"/>
                                <small v-if="errors && errors['email']" class="text-danger mt-2">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Este campo es obligatorio
                                </small>
                                <br>
                                <b-form-input placeholder="IDPDV"  v-model="idpdv" type="text"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;"/>
                                <small v-if="errors && errors['id_pdv']" class="text-danger mt-2">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Este campo es obligatorio
                                </small>
                                <br>
                                <b-form-input placeholder="AXC / MRT" v-model="mrt"  type="text"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;"/>
                                <small v-if="errors && errors['password']" class="text-danger mt-2 text-left">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Este campo es obligatorio
                                </small>
                            </div>
                            <div class="col-md-12">
                                <p v-if="errors && errors['general']" class="mt-4 lead text-danger">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Datos incorrectos
                                </p>
                                <br>
                                <br>
                                <u @click="solucionar()" style="color: #0d6efd; cursor: pointer;">¿Problemas para ingresar?&nbsp; | &nbsp; ¿IDPDV incorrecto?.</u>
                            </div>
                            <div class="col-md-6 text-center">
                                <b-button type="submit" variant="primary" pill  style="margin-top: 25px; width: 20%;" size="sm" >
                                    Ingresar  <b-spinner small v-if="loader"></b-spinner>
                                </b-button>
                                <br> <br> 
                                <br><br>                   
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Coordinador / Subdirector" @click="tipo = 2">
                               <div class="row justify-content-center">
                            <div class="col-md-11 mt-4"> 
                                <p>Ingresa los datos solicitados:</p>
                            </div>
                        
                            <div class="col-md-3 col-11 mt-4">
                                <b-form-input placeholder="Correo"  v-model="email" type="text"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;"/>
                                <small v-if="errors && errors['email']" class="text-danger mt-2">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Este campo es obligatorio
                                </small>
                                <br>
                                <b-form-input placeholder="AXC / MRT" v-model="mrt"  type="text"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;"/>
                                <small v-if="errors && errors['mrt']" class="text-danger mt-2 text-left">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Este campo es obligatorio
                                </small>
                            </div>
                            <div class="col-md-12">
                                <p v-if="errors && errors['general']" class="mt-4 lead text-danger">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Datos incorrectos
                                </p>
                            </div>
                            <div class="col-md-6 mt-5 text-center">
                                <b-button type="submit" variant="primary" pill  style="margin-top: 25px; width: 20%;" size="sm" >
                                    Ingresar  <b-spinner small v-if="loader"></b-spinner>
                                </b-button>
                                <br> <br> 
                                <br><br>                   
                            </div>
                        </div>
                    </b-tab>
                </b-tabs> 
            </div>
        </form>
    </div>
    <div class="row justify-content-center" style="margin-top: -12px;">
        <div class="col-md-5">
            <hr style="border-top: 5px solid #56CB00 !important;  opacity :0.8;">
             <br> <br> 
             <br><br>  
        </div>
    </div>

    <b-modal id="Solucionarpro" title="Solucionar ingreso | IDPDV incorrecto"  hide-footer header-close-content="Cerrar"  header-text-variant="light" header-bg-variant="primary">
        <div class="row  justify-content-center">
            <div class="col-md-11 mt-2">
                <label for="" class="text-secondary">IDPDV</label>
                <b-form-input placeholder="IDPDV" v-model="s_idpdv"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD; " class="mt-1"/>
                <small v-if=" errors2.includes('s_idpdv')" class="text-danger mt-2 text-left">
                        <i class="fas fa-exclamation-circle"></i>
                        Este campo es obligatorios
                </small> 
            </div>
            <div class="col-md-11 mt-2">
                <label for="" class="text-secondary">Correo</label>
                <b-form-input placeholder="Correo electrónico" v-model="s_correo" style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD; " class="mt-1"/>
                <small v-if=" errors2.includes('s_correo')" class="text-danger mt-2 text-left">
                        <i class="fas fa-exclamation-circle"></i>
                        Este campo es obligatorios
                </small> 
            </div>
            <div class="col-md-11 mt-2">
                <label for="" class="text-secondary">AXC / MRT</label>
                <b-form-input placeholder="AXC / MRT" v-model="s_axc" style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD; " class="mt-1"/>
                <small v-if=" errors2.includes('s_axc')" class="text-danger mt-2 text-left">
                        <i class="fas fa-exclamation-circle"></i>
                        Este campo es obligatorios
                </small> 
                <small v-if=" errors2.includes('axc')" class="text-danger mt-2 text-left">
                        <i class="fas fa-exclamation-circle"></i>
                        Datos incorrectos ingresa tu MRT/AXC
                </small> 
            </div>
            <center>
                <b-button  variant="primary" pill  style="margin-top: 25px; width: 40%; background: #039cf3; border-color: #CDCDCD;" size="sm" @click="enviarPro()">
                    Enviar  <b-spinner small v-if="loader"></b-spinner>
                </b-button>
            </center>
          </div>                       
    </b-modal>
</div>
</template>

<script>
import InitController from "@/utils/InitController";
import Swal from 'sweetalert2'
export default {
    name:"cantado",
    data() {
        return {
          errors:[],
          errors2:[],
          loader:false,
          email:"",
          mrt:"",
          idpdv:"",
          isMobile: this.$mobile(),
          tipo: 1,
          s_idpdv:"",
          s_correo:"",
          s_axc:""
        }
    },
    methods:{
        login(e) {
            e.preventDefault();
            this.errors = [];
            this.loader = true;
            var form = {};
            var url = "";

            if (this.tipo == 2) {
                form.mrt = this.mrt;
                form.email = this.email;
                url = "embajador";
            }else{
                form.password = this.mrt
                form.email = this.email
                form.id_pdv = this.idpdv
                url = "experto";
            }

            this.$api.post('auth/login/' + url, form, true).then(({data}) => {
                console.log(data.data);
                this.$store.dispatch("setLogin", data.data);
                this.$router.push("/");
                InitController.startMetrics(data.data);
                this.loader = false;
            }).catch(e => {
                console.log(e);
                this.loader = false;
                if (e.response.data.errors) {
                    this.errors = e.response.data.errors;
                } else {
                  alert("Ocurrió un error desconocido, vuelve a intentarlo más tarde")
                }
            });
        },
        solucionar(){
            this.s_idpdv = "";
            this.s_correo = "";
            this.s_axc = "";
            this.errors2 = [];
            this.$bvModal.show('Solucionarpro')   
        },
        enviarPro(){
            this.loader = true;
            this.errors2 = [];

            if (!this.s_idpdv) {
                 this.loader = false;
                 this.errors2.push('s_idpdv');  
            }if (!this.s_correo) {
                 this.loader = false;
                 this.errors2.push('s_correo');  
            }if (!this.s_axc) {
                 this.loader = false;
                 this.errors2.push('s_axc');  
            }if (this.s_axc.includes("MRT") == false && this.s_axc.includes("MRN") == false && this.s_axc.includes("AXC") == false) {
                 this.loader = false;
                 this.errors2.push('axc');  
            }if (this.errors2.length == 0) {
                 var url= 'cantado/solucionar?idpdv='+ this.s_idpdv + '&axc=' + this.s_axc + '&correo=' + this.s_correo;
                    this.$api.get(url).then(
                        ({data}) => {
                            console.log(data);
                            if (data.valida == 1) {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'IDPDV no vigente.',
                                    text: 'No se encontro el punto de venta.'
                                })
                            }else if(data.valida == 2){
                                  Swal.fire({
                                    icon: 'error',
                                    title: 'Usuario no existe.',
                                    text: 'No se encontro el usuario en la base de datos.'
                                }) 
                            } else {
                                this.s_idpdv = "";
                                this.s_correo = "";
                                this.s_axc = "";
                                this.errors2 = [];
                                this.$bvModal.hide('Solucionarpro')   
                                
                                Swal.fire(
                                    "List@",
                                    "Su solicitud esta en proceso, ingresa de nuevo en 5 minutos.",
                                    'success'
                                    )  
                            }

                            this.loader = false;

                        }
                    );
            }
        }
    },
    mounted(){
        if (this.tipo == 2)
        {
         this.login();   
        }
    }
}
</script>

<style>
 #fondo{
     background-image: url('../../../public/fotos/fondo.png');
     width: 100%!important;
    }

</style>